var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAzure = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#azure_svg__a)",
  d: "M7.706 1.986c.162-.48.613-.804 1.12-.804h7.424L8.544 24.015c-.162.48-.613.803-1.12.803H1.646a1.182 1.182 0 0 1-1.12-1.56z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#0078D4",
  d: "M19.575 16.546h-11.7a.542.542 0 0 0-.37.937l7.518 7.017c.219.205.507.318.806.318h6.625z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#azure_svg__b)",
  d: "M8.826 1.182c-.507 0-.958.324-1.12.804L.526 23.259a1.182 1.182 0 0 0 1.12 1.56h5.778c.507 0 .958-.324 1.12-.804l1.427-4.23 5.052 4.715c.219.205.507.318.806.318h6.625l-2.88-8.273h-8.51L16.25 1.182z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#azure_svg__c)",
  d: "M18.294 1.986a1.18 1.18 0 0 0-1.12-.804h-8.31.037c.508 0 .958.323 1.12.804l7.18 21.273a1.182 1.182 0 0 1-1.12 1.56h-.127 8.4c.808 0 1.378-.794 1.12-1.56z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "azure_svg__a",
  x1: 8.775,
  x2: 1.066,
  y1: 2,
  y2: 24.774,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#114A8B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0669BC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "azure_svg__b",
  x1: 14.936,
  x2: 13.155,
  y1: 16.548,
  y2: 17.151,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.3
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.071,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.321,
  stopOpacity: 0.1
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.623,
  stopOpacity: 0.05
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "azure_svg__c",
  x1: 13.662,
  x2: 22.124,
  y1: 2,
  y2: 24.545,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3CCBF4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2892DF"
})))));
export default SvgAzure;